<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card :title="title" color="primary">
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="-1"
        >
          <p>{{ t }}</p>
          <div v-html="text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseBusinessContact",

  props: {
    dark: Boolean,
    dense: Boolean,
    title: String,
  },

  data: () => ({
    business: [
      {
        icon: "mdi-phone",
        title: "Call",
        text: "079 506 1826",
      },
      {
        icon: "mdi-whatsapp",
        title: "Whatsapp",
        text: "076 859 1572",
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "info@strapp.rent",
      },
    ],
  }),
};
</script>
